export const getEmployeeLocations = async (
  axiosPrivate: any,
  employeeId: string,
  auth: any,
) => {
  try {
    const response = await axiosPrivate.get(
      `/bp_get_employee_locations/${employeeId}`,
      {
        headers: { Authorization: 'Bearer ' + auth.accessToken },
      },
    );
    return response;
  } catch (error) {
    console.error('Error fetching user locations:', error);
    throw error;
  }
};

export const switchUserLocation = async (
  axiosPrivate: any,
  userId: string,
  locationId: string,
  userType: string,
  auth: any,
) => {
  try {
    const { netDebug } = require('../utils/netDebug');
    netDebug.logSnapshot(
      `switch dispatch user=${userId} loc=${locationId} type=${userType}`,
    );
    const clearWatch = netDebug.watchPending('POST /bp_switch_location');
    const response = await axiosPrivate
      .post(
        `/bp_switch_location`,
        {
          user_id: userId,
          location_id: locationId,
          user_type: userType,
        },
        {
          headers: { Authorization: 'Bearer ' + auth.accessToken },
        },
      )
      .finally(clearWatch);

    return response;
  } catch (error) {
    console.error('Error switching location:', error);
    throw error;
  }
};

export const createLocation = async (
  axiosPrivate: any,
  payload: any,
  auth: any,
) => {
  try {
    const response = await axiosPrivate.post(
      `/bp_mobile_create_location`,
      payload,
      {
        headers: { Authorization: 'Bearer ' + auth.accessToken },
      },
    );
    return response;
  } catch (error) {
    console.error('Error creating location:', error);
    throw error;
  }
};

export const getLocationById = async (
  axiosPrivate: any,
  locationId: string,
  auth: any,
) => {
  try {
    const response = await axiosPrivate.get(`/bp_get-location/${locationId}`, {
      headers: { Authorization: 'Bearer ' + auth.accessToken },
    });
    return response;
  } catch (error) {
    console.error('Error fetching location by id:', error);
    throw error;
  }
};

export const updateLocationSettings = async (
  axiosPrivate: any,
  locationId: string,
  payload: any,
  auth: any,
) => {
  try {
    const response = await axiosPrivate.put(
      `/bp_update-location-settings/${locationId}`,
      JSON.stringify(payload),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth.accessToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error('Error updating location settings:', error);
    throw error;
  }
};
